import {
  GENERALMENU_FETCHING,
    GENERALMENU_SUCCESS,
    GENERALMENU_ADD_SUCCESS,
    GENERALMENU_ADD_FAILED,
    GENERALMENU_EDIT_SUCCESS,
    GENERALMENU_EDIT_FAILED,
    GENERALMENU_DELETE_SUCCESS,
    GENERALMENU_DELETE_FAILED,
    GENERALMENU_FAILED,
    GENERALMENU_CLEAR,
  } from "../services/Constants";
  import { GeneralMenu } from "../types/generalmenu.type";
    
    export interface GeneralMenuState {
        result: GeneralMenu[];
        isFetching: boolean;
        isError: boolean;
        isAdddata: boolean,
        isEditdata: boolean,
        isAddError: boolean;
        isEditError: boolean;
        isDeletedata: boolean;
        isDeleteError: boolean;
    }
    
    const initialState: GeneralMenuState = {
        result: [],
        isFetching: false,
        isError: false,
        isAdddata: false,
        isEditdata: false,
        isAddError: false,
        isEditError: false,
        isDeletedata: false,
        isDeleteError: false,
    };
    
    export default (state = initialState, { type, payload}: any) => {
      switch (type) {
        case GENERALMENU_FETCHING:
          return { ...state, result: [], isFetching: true,isAdddata: false,isEditdata: false, 
            isError: false,isAddError: false,isEditError: false,isDeletedata: false,isDeleteError: false};
        case GENERALMENU_SUCCESS:
          return { 
            ...state, 
            result: payload,
            isFetching: false,
            isAdddata: false,
            isEditdata: false,
            isError: false,
            isAddError: false,
            isEditError: false,
            isDeletedata: false,
            isDeleteError: false
          };
          case GENERALMENU_ADD_SUCCESS:
          return { 
            ...state, 
            isFetching: false,
            isAdddata: true,
            isEditdata: false, 
            isError: false,
            isAddError: false,
            isEditError: false,
            isDeletedata: false,
            isDeleteError: false
          };
          case GENERALMENU_EDIT_SUCCESS:
          return { 
            ...state, 
            isFetching: false, 
            isAdddata: false,
            isEditdata: true, 
            isError: false,
            isAddError: false,
            isEditError: false,
            isDeletedata: false,
            isDeleteError: false
          };
        case GENERALMENU_FAILED:
          return { ...state, result: [], isFetching: false,isAdddata: false,isEditdata: false,
             isError: true,isAddError: false,isEditError: false,isDeletedata: false,isDeleteError: false};
        case GENERALMENU_ADD_FAILED:
          return { ...state, result: [], isFetching: false,isAdddata: false,isEditdata: false,
             isError: false,isAddError: true,isEditError: false,isDeletedata: false,isDeleteError: false};
          case GENERALMENU_EDIT_FAILED:
          return { ...state, result: [], isFetching: false,isAdddata: false,isEditdata: false, 
            isError: false,isAddError: false,isEditError: true,isDeletedata: false,isDeleteError: false};
            case GENERALMENU_DELETE_SUCCESS:
          return { ...state, result: [], isFetching: false,isAdddata: false,isEditdata: false, 
            isError: false,isAddError: false,isEditError: false,isDeletedata: true,isDeleteError: false};
            case GENERALMENU_DELETE_FAILED:
          return { ...state, result: [], isFetching: false,isAdddata: false,isEditdata: false, 
            isError: false,isAddError: false,isEditError: false,isDeletedata: false,isDeleteError: true};
        default:
          return state;
      }
      
    };
    